export const flutterEventHandler = (type, data) => {
    // eslint-disable-next-line no-console
    console.log(JSON.stringify({ type, data }));

    window.flutterEventLog.unshift({
        type,
        data,
    });

    if (type === 'offerings') {
        //  window.events.emit('offerings', { offerings })
        app.$bus.$emit("flutter:getOfferings", data);
    }

    if (type === 'iapError') {
        // window.events.emit(message, { sku: '{{ sku }}', errorCode: '{{ errorCode }}', error: '{{ error }}' })
        app.$bus.$emit("flutter:paymentFailed", data);
    }

    if (type === 'iapSuccess') {
        // window.events.emit(message, { sku: '{{ sku }}' })
        app.$bus.$emit("flutter:paymentSucceed", data);
    }

    if (type === 'iapRestoreError') {
        // window.events.emit(message, { error: '{{ error }}' })
        app.$bus.$emit("flutter:paymentRestoreError", data.error);
    }

    if (type === 'iapRestoreSuccess') {
        // window.events.emit(message, { })
        app.$bus.$emit("flutter:paymentRestoreSucceed", {});

    }

    if (type === 'navigation') {
        window.router.push(data['path']);
    }
}

// this.registerBusEvent("flutter:getOfferings", this.updateOfferings);
// this.registerBusEvent("flutter:onOfferingsUpdated", this.updateItems);
// this.registerBusEvent("flutter:paymentRestoreError", this.handleRestoreFailed);
// this.registerBusEvent("flutter:paymentRestoreFailed", this.handleRestoreFailed);
// this.registerBusEvent("flutter:paymentRestoreSucceed", this.handleRestoreSucceed);
// this.registerBusEvent('flutter:paymentSucceed', this.handlePaymentSucceed);
// this.registerBusEvent('flutter:paymentFailed', this.handlePaymentFailed);

// this.registerBusEvent("flutter:paymentStateChanged", this.handlePaymentStateChanged); // @TODO: remove if updated in flutter & in users
// this.registerBusEvent("flutter:paymentError", this.handlePaymentResponse); // @TODO: remove if updated in flutter & in users
// this.registerBusEvent("flutter:paymentStateError", this.handlePaymentResponse); // @TODO: remove if updated in flutter & in users
// this.registerBusEvent("flutter:updateFirstRunTS", this.updateFirstRunTS); // @TODO: remove if updated in flutter & in users
// this.registerBusEvent("flutter:lifecycleStateChanged", (data)); // @TODO: remove if updated in flutter & in users
